export const actions = {
    SET_FULLSCREEN: 'SET_FULLSCREEN',
    REMOVE_FULLSCREEN: 'REMOVE_FULLSCREEN',
};
